module.exports = __webpack_public_path__ + "img/dog.a30cbdfa.gif";